/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Browser_ScreenshotInputs */



/**
* | output |
* | --- |
* | "Viewing web page" |
*
* @param {Chat_Tool_Browser_ScreenshotInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_browser_screenshot = /** @type {((inputs?: Chat_Tool_Browser_ScreenshotInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Browser_ScreenshotInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Webseite wird angesehen")
	return /** @type {LocalizedString} */ ("Viewing web page")
});